import React, { useState } from "react";
import { Drawer, Button, Form, Input, Alert, message } from "antd";
import { gql, useMutation } from "@apollo/client";
import { KeyOutlined, SafetyOutlined } from "@ant-design/icons";
import getWindowSize from "@utils/windowSize";
const CHANGEPASSWORD = gql`
  mutation changePassword($passwordInput: PasswordInput!) {
    changePassword(passwordInput: $passwordInput)
  }
`;

function ChangePassword({ children }) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const windowSize = getWindowSize().innerWidth;

  const [runChangePassword, changePassword] = useMutation(CHANGEPASSWORD, {
    onCompleted(data) {
      if (data.changePassword) setSuccess(true);
      else setSuccess(false);
    },
    onError(error) {
      console.log("خطا: " + error.message);
      setError(error.message);
      setSuccess(false);
    },
  });

  const showDrawer = () => {
    setError(null);
    if (!success) setOpenDrawer(true);
    else message.error("شما به تازگی رمز عبور خود را تغییر داده اید!");
  };
  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };
  const doChangePassword = (passwordInput) => {
    runChangePassword({
      variables: {
        passwordInput,
      },
    });
  };
  return (
    <>
      <Drawer
        title="تغییر رمز عبور"
        placement="right"
        onClose={onCloseDrawer}
        open={openDrawer}
        size={windowSize >= 750 ? "default" : null}
        width={windowSize < 750 ? windowSize - 50 : null}
      >
        {!success ? (
          <Form
            name="normal_login"
            className="login-form"
            onFinish={doChangePassword}
            onValuesChange={() => setError(null)}
          >
            <Form.Item
              style={{ marginBottom: "30px" }}
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: "لطفا رمز عبور فعلی خود را وارد کنید!",
                },
              ]}
              validateStatus={error ? "error" : undefined}
              help={error || undefined}
            >
              <Input.Password
                size="large"
                className="form-input"
                prefix={<KeyOutlined className="site-form-item-icon" />}
                placeholder="رمز عبور فعلی"
              />
            </Form.Item>
            <Form.Item
              style={{ marginBottom: "30px" }}
              name="newPassword"
              rules={[
                {
                  required: true,
                  message: "لطفا رمز عبور جدید را وارد کنید!",
                },
              ]}
            >
              <Input.Password
                size="large"
                className="form-input"
                prefix={<SafetyOutlined className="site-form-item-icon" />}
                placeholder="رمز عبور جدید"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                className="login-form-button"
                htmlType="submit"
                loading={changePassword.loading && true}
              >
                تغییر
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <Alert
            message="عملیات موفق"
            description="رمز عبور شما تغییر کرد"
            type="success"
            showIcon
          />
        )}
      </Drawer>
      <span
        onClick={showDrawer}
        style={{ color: success && "grey", cursor: success && "not-allowed" }}
      >
        {children}
      </span>
    </>
  );
}

export default ChangePassword;
